import css from '@styled-system/css'
import * as React from 'react'
import styled, { StyledComponent, ThemeContext } from 'styled-components'
import {
  color,
  ColorProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  space,
  SpaceProps,
  typography,
  TypographyProps,
} from 'styled-system'

const SvgIcon = (
  props: React.SVGProps<SVGSVGElement> & {
    size?: number | string
    color?: string
  },
) => {
  const { size } = props

  if (size != null) {
    props = {
      width: size,
      height: size,
      ...props,
    }
  }

  const themeContext = React.useContext(ThemeContext)

  if (props.color != null) {
    props = { ...props, color: themeContext.colors[props.color] || props.color }
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      {...props}
    >
      <mask
        id="refresh_svg__a"
        style={{
          maskType: 'alpha',
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={32}
        height={32}
      >
        <path fill="#D9D9D9" d="M0 0h32v32H0z" />
      </mask>
      <g mask="url(#refresh_svg__a)">
        <path
          d="M16 26.666c-2.963 0-5.481-1.037-7.555-3.11C6.37 21.48 5.333 18.962 5.333 16s1.038-5.482 3.112-7.556S13.037 5.333 16 5.333c1.77 0 3.363.361 4.778 1.083a11.198 11.198 0 013.667 3.006V6.444a1.077 1.077 0 011.111-1.111c.318 0 .583.106.794.317.211.21.317.476.317.794v6.533c0 .319-.106.584-.317.795a1.078 1.078 0 01-.794.316h-6.534a1.078 1.078 0 01-1.111-1.111c0-.318.106-.583.317-.794.211-.211.476-.317.794-.317h4.49a9.339 9.339 0 00-3.128-3.133C19.098 7.948 17.637 7.555 16 7.555c-2.355 0-4.352.819-5.989 2.456C8.374 11.648 7.556 13.644 7.556 16c0 2.355.818 4.352 2.455 5.989 1.637 1.637 3.634 2.455 5.99 2.455 1.614 0 3.112-.42 4.494-1.261 1.381-.84 2.424-1.972 3.127-3.394.134-.267.34-.462.617-.584.278-.122.554-.127.828-.016a1 1 0 01.61.6c.112.288.1.574-.032.855a10.422 10.422 0 01-3.912 4.389c-1.725 1.089-3.637 1.633-5.733 1.633z"
          fill="#2BA168"
        />
      </g>
    </svg>
  )
}

type StyledSystemProps = TypographyProps &
  SpaceProps &
  LayoutProps &
  ColorProps &
  PositionProps

const _style = (
  component: React.FC,
): StyledComponent<
  React.FC<
    React.SVGProps<SVGSVGElement> & {
      size?: number | string
      color?: string
    }
  >,
  any,
  StyledSystemProps,
  never
> => {
  const styledSystemProps = [typography, space, layout, color, position]
  return styled(component)(css({}), styledSystemProps)
}

const SvgRefresh = _style(SvgIcon)

export default SvgRefresh
